import React from 'react';
import PropTypes from 'prop-types';


import Logo from '../../images/MathxLogo';
import { useLandingData } from '../../hooks/homePage';
import { useSiteMetadata } from '../../hooks/metadata';
import HeaderShared from '@landing_academy/shared/components-mantine/Header';


function Header({ location }) {
  const { menu } = useLandingData();
  const { title } = useSiteMetadata();

  return (
    <HeaderShared
      menu={menu}
      title={title}
      location={location}
      logo={<Logo />}
    />
  );
}

Header.propTypes = {
  location: PropTypes.object,
};

export default Header;
